import { api } from 'config/index';

const delayPromise = milliseconds => data =>
    new Promise(resolve =>
        setTimeout(() => resolve(data), milliseconds)
    );

const retryPromise = (retries, milliseconds, fn) =>
    fn().then(data => data.status ? Promise.reject('Response with status error') : data)
        .catch(err =>  delayPromise(milliseconds)().then(() =>
            retries > 1
                ? retryPromise(retries - 1, milliseconds, fn)
                : Promise.reject(err))
        );


let cacheObject = {
    result: {},
    promise: {}
};

const fetchApi = {
    get: (url, _headers) => {
        const headers = _headers || {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        };

        return fetch(url, {
            method: 'GET',
            headers
        })
            .then(results => results.json())
    },
    getJson: (url) => fetchApi.get(url, {
        'x-api-key': api.apiKey,
        'Content-Type': 'application/json',
        'pragma': 'no-cache',
        'cache-control': 'no-cache'
    }),
    retry: retryPromise.bind(null, 3, 200),
    getWithCache: (url, cache, renderData = null, transformRender = null, withJson = false) => {
        if (cacheObject.result[cache]) {
            return Promise.resolve(cacheObject.result[cache]);
        }

        if (renderData && window && window.__renderData && window.__renderData[renderData]) {
            return new Promise(resolve => {
                let data = window.__renderData[renderData];

                if(transformRender) data = transformRender(data);

                delete window.__renderData[renderData];
                cacheObject.result[cache] = data;
                resolve(data);
            });
        }

        if (!cacheObject.promise[cache]) {
            const _promise = withJson ? fetchApi.getJson(url) : fetchApi.get(url);
            cacheObject.promise[cache] = fetchApi.retry(() => _promise
                .then(results => {
                    if (!results) return false;
                    cacheObject.result[cache] = results;
                    cacheObject.promise[cache] = null;

                    return results;
                })
                .catch(() => {
                    cacheObject.promise[cache] = null;
                    return false;
                })
            );
        }

        return cacheObject.promise[cache];
    },
    getJsonWithCache: (url, cache, renderData = null, transformRender = null) => fetchApi.getWithCache(url, cache, renderData, transformRender, true)
}

export {
    delayPromise,
    retryPromise
};

export default fetchApi;
